import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11.43 13.93"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M.09 0c-.54 2.81 1.45 8.14 5.05 10.46.41.26.64.33.64.33.05.02.02.06-.01.08l-4.65 2.98s-.05.04-.04.07c.01.02.06 0 .07 0 3.73-1.31 6.44-2.39 8.09-3.18 1.68-.8 2.24-1.25 2.18-1.48-.06-.21-.68-.12-1.19-.17-.47-.04-1.07-.13-1.78-.38C5.76 7.77 3.37 6.56.09 0Z",
      style: {"fill":"#005d63"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "CX-logo"}) } }